import { Box, ImageListItem, ImageListItemBar, Modal, Typography } from "@mui/material";
import React from "react";


const imageListItemSx = {
    cursor: "pointer",
    "& .item-box": {
        transition: "background 0.6s, opacity 0.6s"
    },
    "&:hover": {
        "& .item-box": {
            background: "black",
            opacity: "0.9",

            "& .item-box-text": {
                display: "flex"
            }
        },
        "& .title-bar": {
            opacity: "0"
        }
    }
}


const GalleryCardItem = ({ item }) => {

    const [open, setOpen] = React.useState(false)

    return <>
        <ImageListItem
            onClick={() => setOpen(true)}
            sx={imageListItemSx}
            cols={1}
            rows={1}
            objectfit="cover"
            key={item.id}
            position="relative"
        >

            <Box
                className="item-box"
                sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden"
                }}
            >

                <Typography
                    className="item-box-text"
                    sx={{
                        padding: "15px",
                        display: "none",
                        fontSize: { xs: "6", sm: "15px" },
                        color: "white"
                    }}
                >
                    {item.text}
                </Typography>
            </Box>

            <img
                src={item.image}
                alt=""
                loading="lazy"
                style={{
                    height: "450px",
                    with: "600px",
                    objectFit: "cover"
                }}
            />

            <ImageListItemBar
                sx={{
                    background: "black",
                    color: "inherit",
                    textAlign: "center",
                    opacity: "0.6"
                }}
                position="top"
                className="title-bar"
                title={<Typography variant="h5">{item.header}</Typography>}
            />
        </ImageListItem>
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                outline: "none"
            }}
        >
            <img
                src={item.image}
                alt=""
                loading="lazy"
                style={{ maxHeight: "90%", maxWidth: "90%", outline: "none" }}
            />
        </Modal>
    </>
}

export default GalleryCardItem